import { StyledCta } from 'components/marketingSite/shared/Cta.styled';
import styled from 'styled-components';
import { container, fontSize, screen, spacing } from '../../../theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('lg')};
  padding: ${spacing('xl4')} ${spacing('md')};
  margin: 0;
  text-align: center;
  background-color: #ebd0f4;

  > * {
    max-width: ${container('xl')};
    margin: auto;
    width: 100%;
  }
  > ${StyledCta} {
    max-width: ${container('md')};
  }
`;

export const Header = styled.header`
  text-align: center;
  font-size: ${fontSize('lg')};
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing('lg')};
  width: 100%;

  @media (min-width: ${screen('md')}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const FeaturedCardContainer = styled.div``;
